import { useEffect, useState } from 'react';
import useCustomLinkActions from '@/store/custom-links/useCustomLinksActions';

const alertMessages = {
  expired: {
    title: 'checkout.home.alerts.expired',
    message: 'checkout.home.alerts.expiredMsg',
    link: true,
  },
  inactive: {
    title: 'checkout.home.alerts.inactive',
    message: 'checkout.home.alerts.inactiveMsg',
    link: false,
  },
};

const linkAlertMessages = {
  inactive: {
    title: 'checkout.home.alerts.linkInactive',
    message: 'checkout.home.alerts.linkInactiveMsg',
    link: false,
  },
  expired: {
    title: 'checkout.home.alerts.linkExpired',
    message: 'checkout.home.alerts.linkExpiredMsg',
    link: false,
  },
  used: {
    title: 'checkout.home.alerts.linkUsed',
    message: 'checkout.home.alerts.linkUsedMsg',
    link: false,
  },
};

const allowedStatus = ['inactive', 'expired'];
const linkAllowedStatus = ['inactive', 'expired', 'used'];

export default function useEventAlerts(status) {
  const [alert, setAlert] = useState(null);

  const {
    customLink: { linkStatus, hasCustomLink },
  } = useCustomLinkActions();

  const getAlertStatus = () => {
    if (status === 'expired') {
      setAlert(alertMessages.expired);
      return;
    }
    if (!hasCustomLink && allowedStatus.includes(status)) {
      setAlert(alertMessages[status]);
    }
    if (hasCustomLink && linkAllowedStatus.includes(linkStatus)) {
      setAlert(linkAlertMessages[linkStatus]);
    }
  };

  useEffect(() => {
    getAlertStatus();
  }, [status, hasCustomLink]);

  return { alert };
}
